import { useQuery } from "@tanstack/react-query";
import queryFactory from "./queryFactory";

export default () => {
  return useQuery(queryFactory.categories());
};
